export default __webpack_public_path__ + "static/media/cart.07941d4d.svg";